// extracted by mini-css-extract-plugin
export var adCard = "_pi-8";
export var adCardBorder = "_pi-5";
export var arbiterButtonIcon = "_pi-p";
export var buttonIcon = "_pi-o";
export var container = "_pi-e";
export var copyButton = "_pi-m";
export var darkGrey = "_pi-u";
export var deliveryDate = "_pi-2";
export var divider = "_pi-n";
export var editModeWrapper = "_pi-7";
export var empty = "_pi-a";
export var errorIcon = "_pi-d";
export var filledCircle = "_pi-4";
export var fulfillmentFooter = "_pi-j";
export var grey = "_pi-s";
export var header = "_pi-i";
export var headerWrapper = "_pi-h";
export var highlighted = "_pi-6";
export var historyEntry = "_pi-3";
export var mobileColumn = "_pi-v";
export var mobileColumnReverse = "_pi-w";
export var orderDetailsContainer = "_pi-g";
export var orderMetadata = "_pi-l";
export var orderMetadataWrapper = "_pi-k";
export var packagesContainer = "_pi-b";
export var product = "_pi-y";
export var productImage = "_pi-z";
export var productInfo = "_pi-x";
export var productTitle = "_pi-10";
export var strikethrough = "_pi-t";
export var tinyText = "_pi-r";
export var title = "_pi-9";
export var trackerCard = "_pi-1";
export var trackerCardWrapper = "_pi-0";
export var trackingContainer = "_pi-f";
export var trackingTitle = "_pi-c";
export var xTinyText = "_pi-q";